<template>
    <loading :name="loaderName">
        <div class="container news fix-footer mt-3">
            <div class="col-md-12 main-content pt-3">
                <h2>{{ $t('pages.' + type) }}</h2>
                <hr>
                <div v-for="item in news.data" :key="'news-' + item.slug">
                    <div class="row">
                        <div class="col-sm-6 col-md-4">
                            <router-link :to="getNewsUri(item)">
                                <img v-lazy="item.image" class="featured-img img-fluid">
                            </router-link>
                        </div>
                        <div class="col-sm-6 col-md-8">
                            <h4>{{item.title}}</h4>
                            <p v-html="item.short"></p>
                            <router-link :to="getNewsUri(item)"><span
                                    aria-hidden="true">»</span> {{ $t('button.ReadMore') }}
                            </router-link>
                        </div>
                        <div class="col-12">
                            <hr>
                        </div>
                    </div>
                </div>

                <div class="col-12 mt-5">
                    <paginate
                            v-model="page"
                            :page-count="news.last_page"
                            :click-handler="changePage"
                            :prev-text="$t('button.Prev')"
                            :next-text="$t('button.Next')"
                            :page-class="'page-item'"
                            :container-class="'pagination justify-content-center'">
                    </paginate>
                </div>
            </div>
        </div>
    </loading>
</template>

<script>
  import { mapActions } from 'vuex';
  import { ROUTER_NAMES } from '../../constants';
  import paginationMixin from '../../mixins/paginationMixin';

  export default {
    name: 'NewsList',
    mixins: [paginationMixin],
    created() {
      this.loadContent();
    },
    data() {
      return {
        routeName: ROUTER_NAMES.NEWS_LIST,
        loaderName: 'load  news list'
      };
    },
    computed: {
      news() {
        return this.items[this.page] || {};
      },
      items() {
        return this.$store.state.news.list[this.type];
      },
      type() {
        return this.$route.params.type;
      }
    },
    methods: {
      ...mapActions(['loadNewsList']),
      getNewsUri(news) {
        return `/news/${news.slug}`;
      },
      loadContent(page) {
        this.$wait.start(this.loaderName);

        return this.loadNewsList({
          page: page ? page : this.page,
          type: this.type,
          size: 10
        })
          .then(() => this.$wait.end(this.loaderName));
      }
    }
  };
</script>

<style scoped>

</style>
